export default {
  namespaced: true,
  state: {
    schema: {
      shipments_last_week_count: { type: Number },
      shipments_on_track_count: { type: Number },
      shipments_warning_count: { type: Number },
      shipments_with_incidents_count: { type: Number }
    }
  },
  actions: {
    async retrieve ({ dispatch, state }, id) {
      return dispatch('request', { method: 'get', url: 'shipments/stats' }, { root: true })
        .then(response => { return response.data })
        .catch(error => { throw error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/stats.js